
const DOUBLE_CLICK_TIMEOUT = 500

export class DoubleClickRecognizer {
  _clickCounter = 0

  _timer

  constructor (onSingleClick, onDoubleClick) {
    this.onSingleClick = onSingleClick
    this.onDoubleClick = onDoubleClick
  }

  click = (event) => {
    event.preventDefault()
    this._clickCounter += 1

    if (this._clickCounter === 1) {
      setTimeout(() => {
        this.onSingleClick(event)
      }, 0)
      this._timer = setTimeout(() => {
        this._clickCounter = 0
      }, DOUBLE_CLICK_TIMEOUT)

    } else if (this._clickCounter === 2) {
      clearTimeout(this._timer)
      this._clickCounter = 0
      setTimeout(() => {
        this.onDoubleClick(event)
      }, 0)
    }
  }
}
